module.exports = __webpack_public_path__ + "img/blog.7f9578d7.png";